import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { loadRedirects, normalizePath } from '@/lib/redirectStore';

// In-app redirect engine. Handles admin-managed redirects whose source is a
// REAL app route (e.g. legacy /category/<old-slug>). Unknown paths are handled
// by the NotFound catch-all (which shares the same map). NOTE: client-side
// redirect (HTTP 200 + redirect) — apply the exported Cloudflare/nginx rules
// from Admin → Redirects for true edge HTTP 301/302.
const RedirectGate = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [map, setMap] = useState(null);

  useEffect(() => { loadRedirects().then(setMap); }, []);

  useEffect(() => {
    if (!map) return;
    const hit = map[normalizePath(location.pathname)];
    if (!hit) return;
    if (/^https?:\/\//.test(hit.destination)) window.location.replace(hit.destination);
    else navigate(hit.destination, { replace: hit.type === 301 });
  }, [location.pathname, map, navigate]);

  return null;
};

export default RedirectGate;
